import { tableHelper } from "@/helpers/table.helper";
import * as mutation from "./mutation-types";

export const state = getInitialState();

export function getInitialState() {
  return {
    listing: {
      data: [],
      levyCollectionId: null,
      paging: tableHelper.getDefaultPaging("Type", false),
      loading: false,
      loaded: false
    },
    edit: {
      data: {},
      levyCollectionId: null,
      type: null,
      loading: false,
      saving: false,
      error: {
        show: false,
        details: {},
        hideMutation: mutation.STATE_HIDE_ERROR,
        hideArgument: "edit"
      }
    }
  };
}

export function getUnloadedState() {
  return {
    listing: {
      loaded: false
    }
  };
}
